/**
 * Image URL normalization and error fallback utility
 */

export const normalizeImageUrl = (url?: string | null): string => {
  if (!url || typeof url !== 'string') return '';
  let clean = url.trim();
  if (!clean) return '';

  // If already a data URI or blob URL, return as is
  if (clean.startsWith('data:') || clean.startsWith('blob:')) {
    return clean;
  }

  // If it's already a full URL
  if (clean.startsWith('http://') || clean.startsWith('https://')) {
    if (clean.includes('basseraa.com/uploads/') && !clean.includes('basseraa.com/uploads/uploads/')) {
      clean = clean.replace('basseraa.com/uploads/', 'basseraa.com/uploads/uploads/');
    }
    return clean;
  }

  // Remove leading slashes or uploads prefixes to get relative path
  clean = clean.replace(/^\/+/, '');
  clean = clean.replace(/^uploads\/uploads\//i, '');
  clean = clean.replace(/^uploads\//i, '');

  return `https://www.basseraa.com/uploads/uploads/${clean}`;
};

/**
 * Returns a fallback placeholder image if an image fails to load
 */
export const getFallbackAvatar = (name?: string): string => {
  const safeName = encodeURIComponent(name || 'User');
  return `https://ui-avatars.com/api/?name=${safeName}&background=e2e8f0&color=64748b&bold=true`;
};

/**
 * Common SVG placeholder for missing images
 */
export const FALLBACK_PRODUCT_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m21 16-4-4-4 4-4-4-4 4'/%3E%3Crect width='18' height='18' x='3' y='3' rx='2' ry='2'/%3E%3Ccircle cx='9' cy='9' r='2'/%3E%3C/svg%3E";

